import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: 15px;
`

export const LastLink = styled.span`
  color: ${(p) => p.theme.uiKit.colors.global.general.secondary};
  font-size: ${(p) => p.theme.uiKit.fontSize.bodyM};
  line-height: ${(p) => p.theme.uiKit.lineHeights.m};
  display: flex;
`

export const Arrow = styled.b`
  display: block;
  color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
`

export const PrevLink = styled.div`
  a,
  a:hover,
  a:focus,
  a:visited {
    color: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
    font-size: ${(p) => p.theme.uiKit.fontSize.bodyM};
    line-height: ${(p) => p.theme.uiKit.lineHeights.m};
    text-decoration: none;
  }
`
